// extracted by mini-css-extract-plugin
module.exports = {"container":"lab_container__320h8","btnFullWidthClose":"lab_btnFullWidthClose__3YiR0","hidden":"lab_hidden__3KMWC","outputsContainer":"lab_outputsContainer__1H0dQ"};